import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import { register, RegisterParams } from 'store/modules/user/actions';

import { Props as ButtonProps } from 'components/layout/Button';
import { Props as ButtonGroupProps } from 'components/layout/ButtonGroup';

import Component from './component';

export interface Props extends ParentProps {
    actions: {
        register: (params: RegisterParams) => Promise<any>;
    };
}
export interface ParentProps {
    title: string;
    headline: {
        register: string;
        data: string;
    };
    input: {
        phonePrefix: {
            label: string;
            placeholder: string;
            initialValue: string;
        };
        phone: {
            label: string;
            placeholder: string;
        };
        password: {
            label: string;
            placeholder: string;
            title: string;
            validation: PasswordValidation[];
        };
        email: {
            label: string;
            placeholder: string;
        }
        firstName: {
            label: string;
            placeholder: string;
        };
        lastName: {
            label: string;
            placeholder: string;
        };
        regulations: string;
        phoneMarketing: string;
        phoneMarketingClients: string;
        emailMarketing: string;
        emailMarketingClients: string;
    }
    buttonProps: ButtonProps;
    buttonGroupProps: ButtonGroupProps;
    onSuccess?: (response: any) => any;
    phoneForm: Boolean;
    emailForm: Boolean;
    loginMobile: ButtonProps;
    registerMobile: ButtonProps;
    helper: string;
}

export interface Errors {
    email: string;
    password: string;
    phone: string;
    phonePrefix: string;
    firstName: string;
    lastName: string;
    registerType: string;
    userAgrees: string;
    recaptchaToken: string;
}
interface PasswordValidation {
    name: string;
    value: string;
}

const mapDispatchToProps = (dispatch: Dispatch): object => {
    return {
        actions: {
            register: bindActionCreators(register, dispatch),
        },
    };
};

Component.defaultProps = {
    onSuccess: null,
};

export default connect(null, mapDispatchToProps)(Component);